import "@/App.css";
import ReduxProvider from "@/core/redux/redux-provider";
import Router from "@/routes/sections";
import DefaultLayout from "@/shared/layouts/default-layout/default-layout";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./core/context/AuthProvider";
import { Toaster } from "./shared/components/ui/toaster";
import { ShortkeysProvider } from "./core/context/ShortKeyContext";
import { ResetProvider } from "./core/context/ResetContext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Agentation } from "agentation";

function App() {
  return (
    <BrowserRouter>
      <ResetProvider>
        <ReduxProvider>
          <DndProvider backend={HTML5Backend}>
            <DefaultLayout>
              <AuthProvider>
                <ShortkeysProvider>
                  <Router />
                </ShortkeysProvider>
              </AuthProvider>
            </DefaultLayout>
            <Toaster />
            {process.env.NODE_ENV === "development" && <Agentation endpoint="http://localhost:4747" />}
          </DndProvider>
        </ReduxProvider>
      </ResetProvider>
    </BrowserRouter>
  );
}

export default App;
